import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from "@angular/core";

@Component({
    selector: "lg-count",
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: ` {{ count }} `,
    host: {
        "[class.lg-button__count]": "true",
        "[class.lg-button__count--no-padding]": "count < 10",
        "[class.lg-button__count--hidden]": "hideEmpty && count === 0"
    }
})
export class LgCountComponent {
    /**
     * Count (required).
     *
     */
    @Input({ required: true }) count!: number;

    /**
     * Specify if counter should be hidden if count is 0 (default true).
     *
     */
    @Input() hideEmpty = true;
}
